/** Recursive deep object comparison. Note: isObjEqual({a: undefined}, {}) === true */
export const isObjEqual = (a: unknown, b: unknown): boolean => {
  if (a === b) return true;
  if (a === null || a === undefined || b === null || b === undefined)
    return false;

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!isObjEqual(a[i], b[i])) return false;
    }
    return true;
  }

  if (typeof a !== "object" || typeof b !== "object") return false;

  // filter out keys that have value undefined (they count as not existing)
  const keysA = Object.keys(a).filter(
    (key) => a[key as keyof typeof a] !== undefined
  );
  const keysB = Object.keys(b).filter(
    (key) => b[key as keyof typeof b] !== undefined
  );

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key)) return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    if (!isObjEqual((a as any)[key] as unknown, (b as any)[key])) return false;
  }

  return true;
};

export const isArraySetEqual = <T>(a: T[], b: T[]): boolean => {
  if (a.length !== b.length) return false;
  return (
    a.every((item) => b.includes(item)) && b.every((item) => a.includes(item))
  );
};
